/* eslint-disable react/no-unused-state */
import * as partnerPlanFormSchema from 'schemas/forms/PartnerPlanForm'
import Heading from 'components/Heading'
import Modal from 'components/Modal'
import { validateAll } from 'utils/validators'
import React, { PropTypes, Component } from 'react'
import SelectInput from 'components/Form/components/SelectInput'
import SubmitButton from 'components/SubmitButton'
import TextInput from 'components/Form/components/TextInput'
import Alert from 'components/Alert'
import styles from './PartnerPlanDisplayForm.scss'
import constants from 'constants'
// import moment from 'moment'
import { format } from 'date-fns'
import FileUploader from 'components/FileUploader/FileUploader'
import FineUploaderTraditional from 'fine-uploader-wrappers'
import { agent } from 'utils/api'
import { getConfig } from 'utils/config'
import { notify } from 'utils/notification'

import {
  formUpdate,
  formInit,
  formSubmit,
  formReset,
} from 'actions/forms'

class FinalPlanDisplayForm extends Component {
  static propTypes = {
    completeText: PropTypes.string,
    confirmation: PropTypes.bool,
    ctaText: PropTypes.string,
    data: PropTypes.object,
    description: PropTypes.string,
    dispatch: PropTypes.func.isRequired,
    forms: PropTypes.object.isRequired,
    handleFormSubmit: PropTypes.func,
    handleSubmit: PropTypes.func.isRequired,
    hide: PropTypes.func.isRequired,
    id: PropTypes.string,
    modals: PropTypes.object.isRequired,
    partnerPlan: PropTypes.object,
    selectedPlan: PropTypes.object.isRequired,
    show: PropTypes.bool,
    submittingText: PropTypes.string,
    title: PropTypes.string,
  }
  static defaultProps = {
    data: {},
    ctaText: 'Submit',
    completeText: 'Submitted',
    submittingText: 'Submitting',
    show: false,
    confirmation: false,
    description: '',
    handleFormSubmit: null,
    id: `${constants.PARTNERPLAN.FORMS.FINAL}`,
    title: '',
    partnerPlan: null,
  }

  constructor() {
    super()

    this.state = {
      submittedFiles: [],
      uploader: null,
    }
  }

  componentWillMount() {
    const { formFields } = partnerPlanFormSchema

    const formData = {
      formFields,
      data: this.props.data || null,
    }

    this.props.dispatch(formInit(this.props.id, formData))
    this.setState({ uploader: this.myUploader() })
    this.setState({ submittedFiles: [] })
  }

  componentWillReceiveProps(nextProps) {
    const modalCreated = this.props.modals.finalPlanForm
    const modalChanged = modalCreated && nextProps.modals.finalPlanForm.show !== this.props.modals.finalPlanForm.show
    const modalNotVisible = modalCreated && !nextProps.modals.finalPlanForm.show
    const modalVisible = modalCreated && nextProps.modals.finalPlanForm.show
    // const dataChanged = nextProps.data !== this.props.data

    if (modalChanged && modalNotVisible) {
      this.props.dispatch(formReset(this.props.id))
    }

    if (modalChanged && modalVisible) {
      // preload data from BED if needed
      this._handleChange('role', this.props.selectedPlan.Role)
      this._handleChange('planStatus', this.props.partnerPlan.partnerPlan.planStatus)
      // this._handleSelectChange('finalCounselleeAssessment', (this.props.partnerPlan.partnerPlan.finalCounselleeAssessment !== '' ? this.props.partnerPlan.partnerPlan.finalCounselleeAssessment : ''))
      // this._handleChange('finalCounselleeComments', this.props.partnerPlan.partnerPlan.finalCounselleeComments)
    }
  }

  setSubmittedFiles = (submittedFiles) => {
    this.setState({ submittedFiles })
  }

  setFileUploaderResponse = (response) => {
  }

  _schema = () => {
    const obj = {}
    partnerPlanFormSchema.formFields.forEach((field) => {
      obj[field.name] = field
    })
    return obj
  }

  _hide = () => {
    this.props.hide(this.props.id)
    this.props.dispatch(formReset(this.props.id))
  }

  _handleFormSubmit = () => {
    this.setState({ submittedFiles: [] })
    const values = this.props.forms[this.props.id]
    const data = {}
    Object.keys(values).forEach((key) => {
      if (key.indexOf('_') < 0) {
        data[key] = values[key].value
      }
    })
    data.year = (this.props.selectedPlan.PlanYear ? this.props.selectedPlan.PlanYear : '')
    // plan should be submitted via neota logic for interim assessment status remains the same
    // data.planStatus = constants.PARTNERPLAN.STATUS.FINAL_ASSESSMENT_SUBMITTED
    // data.finalDate = `${format(new Date(), constants.DATE_FORMAT.STANDARD_ISO)}`
    this.props.handleSubmit(data)
  }

  _handleSubmit = (e) => {
    e.preventDefault()
    const values = this.props.forms[this.props.id]
    const data = {}
    Object.keys(values).forEach((key) => {
      if (key.indexOf('_') < 0) {
        data[key] = values[key].value
      }
    })

    // Validate all the forms fields and return any errors
    const errors = validateAll(partnerPlanFormSchema.requiredFields, this.props.forms[this.props.id])
    // Check if form has errors
    if (errors.length > 0) {
      // If form has errors handle them
      errors.forEach((errObj) => {
        this._handleError(errObj, errObj.name)
      })
    } else {
      // If form has no errors, pass the serialized form field for submit and set the form to submit.
      // append or map existing data
      this.props.dispatch(formSubmit(this.props.id))

      if (this.state.submittedFiles.length > 0) {
        this.state.uploader.methods.uploadStoredFiles()
      } else {
        this._handleFormSubmit()
      }
    }
  }

  _handleAllUploadComplete = (id, name, response) => {
    this._handleFormSubmit()
    /* if (response.success) {
      this._handleFormSubmit()
    } else {
    } */
  }

  _handleUploadComplete = (id, name, response) => {
    /*
    if (response.success) {
      this._handleFormSubmit()
    } else {
      this.props.dispatch(notify(response.error))
      // this.props.dispatch(formReset(this.props.id))
    } */
  }

  _handleUploadError = (id, name, response) => {
    setTimeout(() => { this.props.dispatch(notify((response.error ? response.error : response))) }, 2000)
    // this.props.dispatch(formReset(this.props.id))
  }

  // Takes an error object for a field and updates the state accordingly
  _handleError(errorObj, stateKey) {
    // Set new state value for field and update state
    const stateValue = {
      data: {
        focus: false,
        error: (errorObj.valid) ? '' : errorObj.error,
        valid: errorObj.valid,
      },
      field: stateKey,
    }
    this._handleState(stateValue)
  }

  _handleState = (stateValue) => {
    this.props.dispatch(formUpdate(this.props.id, stateValue))
  }

  _handleValidation = (name) => {
    const stateValue = {
      field: name,
      data: {
        focus: false,
      },
    }

    this.props.dispatch(formUpdate(this.props.id, stateValue))
  }

  _handleFocus = (name) => {
    // Create state value obj
    const stateValue = {
      field: name,
      data: {
        focus: true,
      },
    }

    this.props.dispatch(formUpdate(this.props.id, stateValue))
  }

  _handleAutoComplete = (name, value) => {
    this._handleChange(name, value)
  }

  // Handle Changes on form elements
  _handleChange = (name, value) => {
    /*
      Create state value obj
      Reset error handling (Stops error check on focus changes)
    */
    const stateValue = {
      field: name,
      data: {
        value,
        error: '',
        valid: true,
      },
    }
    // Pass state value and handle state
    this.props.dispatch(formUpdate(this.props.id, stateValue))
  }

  _handleSelectChange = (name, value, selectedIndex) => {
    /*
      Create state value obj
      Reset error handling (Stops error check on focus changes)
    */
    const stateValue = {
      field: name,
      data: {
        value,
        error: '',
        valid: true,
        selectedIndex,
      },
    }
    // Pass state value and handle state
    this.props.dispatch(formUpdate(this.props.id, stateValue))
  }

  // Moving logic from Uploader ...
  myUploader = () => {
    const { selectedPlan } = this.props
    // const { allowedExtensions, uploadID, maxFileSize } = this.props
    const allowedExtensions = constants.PARTNERPLAN.ALLOWEDEXTENSIONS
    // const uploadID = '1234'
    const maxFileSize = constants.PARTNERPLAN.MAX_FILESIZE
    const maxFileNumber = 10

    return new FineUploaderTraditional({
      options: {
        debug: true,
        autoUpload: false,
        request: {
          endpoint: agent.FileUploader.uploadplan(),
          params: {
            loginname: selectedPlan.LoginName,
            employee_id: selectedPlan.EmployeeId,
            year: selectedPlan.PlanYear,
            PlanStatus: selectedPlan.PlanStatus,
            DocType: constants.PARTNERPLAN.DOCUMENTTYPE.FINAL,
            LibraryName: getConfig().PLAN_LIBRARY,
            CPEmail: (selectedPlan.CPEmail ? selectedPlan.CPEmail : constants.PARTNERPLAN.FILLER_EMPTY_HIERARCHY),
            MLEmail: (selectedPlan.MLEmail ? selectedPlan.MLEmail : constants.PARTNERPLAN.FILLER_EMPTY_HIERARCHY),
            BLEmail: (selectedPlan.BLEmail ? selectedPlan.BLEmail : constants.PARTNERPLAN.FILLER_EMPTY_HIERARCHY),
            CILEmail: (selectedPlan.CILEmail ? selectedPlan.CILEmail : constants.PARTNERPLAN.FILLER_EMPTY_HIERARCHY),
            BUCOOEmail: (selectedPlan.BUCOOEmail ? selectedPlan.BUCOOEmail : constants.PARTNERPLAN.FILLER_EMPTY_HIERARCHY),
            OLEmail: (selectedPlan.OLEmail ? selectedPlan.OLEmail : constants.PARTNERPLAN.FILLER_EMPTY_HIERARCHY),
            OPLEmail: (selectedPlan.OPLEmail ? selectedPlan.OPLEmail : constants.PARTNERPLAN.FILLER_EMPTY_HIERARCHY),
          },
          paramsInBody: true,
        },
        cors: {
          expected: true,
          sendCredentials: true,
        },
        // deleteFile: {
        //   enabled: true,
        // },
        validation: {
          acceptFiles: allowedExtensions.map(e => `.${e}`),
          allowedExtensions,
          sizeLimit: maxFileSize,
          itemLimit: maxFileNumber,
        },
        chunking: {
          enabled: false,
          partSize: 5242880, // 5mb
          concurrent: {
            enabled: true,
          },
          success: {
          },
        },
        callbacks: {
          // onSubmit: this.uploaderSubmit,
          // onSubmitted: this.uploaderSubmitted,
          // onComplete: this._handleFormSubmit,
          onError: this._handleUploadError,
          // onStatusChange: this.uploaderStatusChange,
          // onProgress: this.uploaderProgress,
          // onUploadChunk: this.uploadChunk,
          // onUploadChunkSuccess: this.uploadChunkSuccess,
          // onUpload: this.startUpload,
          // onAllComplete: this._handleFormSubmit,
          onAllComplete: this._handleAllUploadComplete,
          // onCancel: this.onCancel,
          // onDelete: this.onDelete,
        },
      },
    })
  }

  canSubmit = () => {
    const form = this.props.forms[this.props.id]
    return (this.state.submittedFiles.length > 0)
  }

  render() {
    const {
      ctaText,
      completeText,
      submittingText,
      title,
      dispatch,
      modals,
      description,
    } = this.props
    const schema = this._schema()
    const form = this.props.forms[this.props.id]
    const disable = (form && form._isPosting)
    const forceClose = (form && form._hasCompleted)
    const formHasFetched = this.props.hasFetched
    
    return (
      <Modal
        className={styles.bg}
        disable={disable}
        dispatch={dispatch}
        forceClose={forceClose}
        id={constants.PARTNERPLAN.FORMS.FINAL}
        modals={modals}
        onClose={this._hide}
      >
        <div className={styles.base}>
          <Heading className={styles.title} size="large">
            {title}
          </Heading>
          <p className={styles.content}>{description}</p>
          {form &&
          <form
            className={styles.form}
            id={this.props.id}
            noValidate="novalidate"
            onSubmit={this._handleSubmit}
          >
            <div className={styles.sectionHeader} />
            <fieldset>
              <ul>
                <TextInput
                  {...schema.planStatus}
                  handleChange={this._handleChange}
                  onBlur={this._handleValidation}
                  onFocus={this._handleFocus}
                  text={form.planStatus.value}
                />
                <TextInput
                  {...schema.role}
                  handleChange={this._handleChange}
                  onBlur={this._handleValidation}
                  onFocus={this._handleFocus}
                  text={form.role.value}
                />
                <TextInput
                  {...schema.partnerFinalAssessment}
                  handleChange={this._handleChange}
                  onBlur={this._handleValidation}
                  onFocus={this._handleFocus}
                  text={form.partnerFinalAssessment.value}
                  type="hidden"
                />
                <TextInput
                  {...schema.partnerFinalAssessmentComments}
                  multiline
                  error={form.partnerFinalAssessmentComments.error}
                  focus={form.partnerFinalAssessmentComments.focus}
                  handleChange={this._handleChange}
                  onBlur={this._handleValidation}
                  onFocus={this._handleFocus}
                  text={form.partnerFinalAssessmentComments.value}
                  type="hidden"
                  valid={form.partnerFinalAssessmentComments.valid}
                />                
                <li>
                  <Alert type="info">
                  Ensure filenames only use numbers, letters and underscores.
                  </Alert>
                  <FileUploader
                    multiple
                    allowedExtensions={constants.PARTNERPLAN.ALLOWEDEXTENSIONS}
                    handleDeleteExistingFile={file => console.log('### delete', file)}
                    handleSelectedFile={() => console.log('### selected ###')}
                    labelWidth={20}
                    maxFileSize={constants.PARTNERPLAN.MAX_FILESIZE} // 1 MB = 1000 * 1000 * 1024 bytes
                    setFileUploaderResponse={this.setFileUploaderResponse}
                    setSubmittedFiles={this.setSubmittedFiles}
                    // disabled={fileUploaderDisabled}
                    uploadDescText={constants.PARTNERPLAN.FILE_UPLOAD_DESC}
                    uploadTitle="Add files here"
                    uploader={this.state.uploader}
                  />
                </li>
              </ul>
            </fieldset>
            <br /><br />
            <div className={styles.footer}>
              <SubmitButton
                isLarge
                complete={this.props.forms[this.props.id]._isComplete}
                completeText={completeText} // Add validation rules
                disabled={!this.canSubmit()}
                submitting={this.props.forms[this.props.id]._isPosting}
                submittingText={submittingText}
              >
                {ctaText}
              </SubmitButton>
            </div>
          </form>
        }
        </div>
      </Modal>
    )
  }
}

export default FinalPlanDisplayForm



// WEBPACK FOOTER //
// ./src/views/PartnerPlans/FinalPlanDisplayForm.js